import React from "react";
import { Flex, Box, Text, Spacer, Divider } from "@chakra-ui/react";
import StatColumn from "./StatColumn";
import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { format, getNum } from "../../Utils/number";

const selector = ({ stabilityDeposit, starBalance, STARPrice }: LiquityStoreState) => ({
  stabilityDeposit,
  starBalance,
  STARPrice
});

const PoolSummary: React.FC = () => {
  const { stabilityDeposit, starBalance, STARPrice } = useLiquitySelector(selector);
  const balance = format(starBalance);
  const deposited = format(stabilityDeposit.currentSTAR);

  return (
    <Box flex={1}>
      <Text textStyle="title3" textAlign={["center", "left"]} pb={6}>
        Stability Pool Summary
      </Text>
      <Divider mb={5} height="0.5px" opacity="0.4" />
      <Flex>
        <StatColumn
          iconName="STAR"
          amount={getNum(deposited, 2)}
          units="STAR"
          description="Deposited in Stability Pool"
        />
        <Spacer />
        <StatColumn
          iconName="STAR"
          amount={getNum(balance, 2)}
          units="STAR"
          description="STAR Balance in Wallet"
        />
      </Flex>

      {/* <Text textStyle="title3" textAlign="center" pt={10} color="purple">
        STAR Price: ${STARPrice.toString(3)}
      </Text> */}
    </Box>
  );
};

export default PoolSummary;
